import { ApiResourceFactory } from '../api.resource.factory'
import { HistoryModel, ResponseListModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IHistoryService {
    getHistoryForLocation(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForDevice(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForMeter(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForIssue(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForTask(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForAlarm(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForAction(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
    getHistoryForReport(id: number, state?: any): ng.IPromise<ResponseListModel<HistoryModel>>
}

export class HistoryService implements IHistoryService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getHistoryForLocation(id: number, state: any = {}) {
        var get = this.apiResource.history['getLocationHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForDevice(id: number, state: any = {}) {
        var get = this.apiResource.history['getDeviceHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForMeter(id: number, state: any = {}) {
        var get = this.apiResource.history['getMeterHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForIssue(id: number, state: any = {}) {
        var get = this.apiResource.history['getIssueHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForTask(id: number, state: any = {}) {
        var get = this.apiResource.history['getTaskHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForAlarm(id: number, state: any = {}) {
        var get = this.apiResource.history['getAlarmHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForAction(id: number, state: any = {}) {
        var get = this.apiResource.history['getActionHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForSimcard(id: number, state: any = {}) {
        var get = this.apiResource.history['getSimcardHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getHistoryForReport(id: number, state: any = {}) {
        var get = this.apiResource.history['getReportHistory']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
